import React from "react";
import styled from "styled-components";

const Pill = styled.div`
    padding: 1em 2.5em;
    background-color: rgb(255 255 255 / 0.4);
    border-radius: 999px;
    width: fit-content;
    margin: 2em auto;

    h1 {
        margin: 0;
        font-size: 3em;
        text-transform: uppercase;
        font-weight: bold;
        color: var(--kpum-orange);

        @supports (-webkit-background-clip: text) {
            background: linear-gradient(45deg, var(--kpum-orange), var(--kpum-lightorange));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        position: relative;
        z-index: 1;
    }
`;

const GradientTitle = ({ children, style, className }) => (
    <Pill style={style} className={className}>
        <h1>{children}</h1>
    </Pill>
);

export default GradientTitle;